export default __webpack_public_path__ + "static/media/vacuum.fcb018b5.svg";